import React, { useMemo } from 'react';
import { Timeline as FlowBiteTimeLine } from 'flowbite-react';
import { CheckIcon } from '@heroicons/react/24/outline';

import { cn, getAssetSrc } from '@restworld/utils-common';

const { Item, Content, Title, Body } = FlowBiteTimeLine;

export interface TimelineProps {
  timeLineSteps: {
    key?: number;
    title: string;
    subtitle?: string;
    checked?: boolean;
    isFlagged?: boolean;
  }[];
}
export const Timeline = ({ timeLineSteps }: TimelineProps) => {
  const items = useMemo(
    () =>
      timeLineSteps.map(({ key, title, subtitle, checked, isFlagged }, i, list) => {
        const icon = checked ? (
          <CheckIcon strokeWidth={3} className="h-3 w-3 text-primary-300 text-bold" />
        ) : isFlagged ? (
          <img src={getAssetSrc('/utils-assets/flag-checkmark.svg')} alt="" />
        ) : (
          key
        );
        const verticalLine = list.length - 1 !== i ? <VerticalLineStyled /> : null;
        return (
          <ItemStyled key={title} twstyle={list.length - 1 === i ? 'mb-0' : ''}>
            <TimeLineIconWrapper>
              <TimeLineIcon>{icon}</TimeLineIcon>
              {verticalLine}
            </TimeLineIconWrapper>
            <Content>
              <TitleStyled>{title}</TitleStyled>
              {subtitle ? <BodyStyled>{subtitle}</BodyStyled> : null}
            </Content>
          </ItemStyled>
        );
      }),
    [timeLineSteps]
  );
  return <FlowBiteTimeLineStyled>{items}</FlowBiteTimeLineStyled>;
};
export default Timeline;
// --> parent > styled components
const FlowBiteTimeLineStyled = (props: React.ComponentProps<typeof FlowBiteTimeLine>) => (
  <FlowBiteTimeLine {...props} className={cn('border-primary-800 ml-3 border-none', props.className)} />
);
const VerticalLineStyled = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <span className={cn('border-[1.5px] border-primary-800 h-14 absolute left-3 top-8', className)} {...props} />
);
const ItemStyled = ({ twstyle, className, ...props }: { twstyle?: string } & React.ComponentProps<typeof Item>) => (
  <Item className={cn('mb-6', twstyle, className)} {...props} />
);
const TitleStyled = (props: React.ComponentProps<typeof Title>) => (
  <Title {...props} className={cn('text-base', props.className)} />
);
const BodyStyled = (props: React.ComponentProps<typeof Body>) => (
  <Body {...props} className={cn('text-gray-600', props.className)} />
);
const TimeLineIconWrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <span
    className={cn(
      'absolute flex items-center justify-center w-6 h-6 bg-primary-50 rounded-full -left-3 ring-8 ring-white dark:ring-gray-900 dark:bg-blue-900',
      className
    )}
    {...props}
  />
);
const TimeLineIcon = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <span className={cn('text-primary-800 text-xs', className)} {...props} />
);
export * from './timeline.mocks';
